class SliderComponent extends HTMLElement {
  constructor() {
    super()
    this.slider = this.querySelector('ul')
    this.sliderItems = this.querySelectorAll('li')
    this.pageCount = this.querySelector('.slider-counter--current')
    this.pageTotal = this.querySelector('.slider-counter--total')
    this.prevButton = this.querySelector('button[name="previous"]')
    this.nextButton = this.querySelector('button[name="next"]')
    this.dotsContainer = this.querySelector('.js-slider-buttons-dots')

    if (!this.slider) {
      return
    } else if (!this.dotsContainer && !this.nextButton) {
      return
    }

    if (this.sliderItems.length > 0) {
      const resizeObserver = new ResizeObserver((entries) => this.initPages())
      resizeObserver.observe(this.slider)
    }

    this.slider.addEventListener('scroll', this.update.bind(this))
    if (this.nextButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this))
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this))
    }

    if (this.dotsContainer) {
      this.addEventListener('click', (e) => {
        if (e.target.classList.contains('js-slider-dot')) {
          e.preventDefault()
          this.onDotClick(e.target)
        }
      })
    }

    this.equalHeight(false)
    window.addEventListener(
      'resize',
      (() => {
        this.equalHeight(true)
      }).bind(this)
    )
  }

  onDotClick(button) {
    const itemPosition = button.dataset.page
    let slideScrollPosition = this.sliderItems[0].clientWidth * itemPosition

    if (window.innerWidth < 990 && this.slider.dataset.mobileOffset) {
      slideScrollPosition =
        slideScrollPosition - this.sliderItems[0].clientWidth / 2
    }

    this.slider.scrollTo({
      left: slideScrollPosition < 0 ? 0 : slideScrollPosition,
    })
  }

  equalHeight = (resize) => {
    let elements = this.slider.querySelectorAll('.equalHeight'),
      allHeights = []

    if (resize === true) {
      elements.forEach((element) => {
        element.style.height = 'auto'
      })
    }

    elements.forEach((element) => {
      let elementHeight = element.clientHeight
      allHeights.push(elementHeight)
    })

    elements.forEach((element) => {
      element.style.height = Math.max.apply(Math, allHeights) + 'px'
      if (resize === false) {
        element.classList.add('show')
      }
    })
  }

  initPages() {
    if (this.sliderItems.length === 0) return
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItems[0].clientWidth
    )
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1
    this.addDots()
    this.update()
    if (
      window.innerWidth < 990 &&
      this.slider.dataset.mobileOffset &&
      this.dotsContainer
    ) {
      //this.onDotClick(this.dotsContainer.querySelectorAll('.js-slider-dot')[1]);
      let hasClass = this.dotsContainer
      let active = this.dotsContainer.querySelectorAll('.js-slider-dot')
      if (hasClass.classList.contains('featured-blog-articles__dots')) {
        active.forEach((element, index) => {
          if (index == 0) {
            element.click()
          }
        })
      } else {
        active.forEach((element, index) => {
          if (index == 1) {
            element.click()
          }
        })
      }
    }
  }

  update() {
    if (!this.dotsContainer && (!this.pageCount || !this.pageTotal)) {
      return
    }

    this.removeDotsActiveClass()
    const newPage =
      Math.ceil(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1
    if (newPage !== this.currentPage) {
      this.currentPage = newPage

      if (
        this.slider.dataset.scrollCallback &&
        typeof window[this.slider.dataset.scrollCallback] === 'function'
      ) {
        window[this.slider.dataset.scrollCallback](this)
      }
    }

    if (this.prevButton) {
      if (this.currentPage === 1) {
        this.prevButton.setAttribute('disabled', true)
      } else {
        this.prevButton.removeAttribute('disabled')
      }
    }

    if (this.nextButton) {
      if (this.currentPage === this.totalPages) {
        this.nextButton.setAttribute('disabled', true)
      } else {
        this.nextButton.removeAttribute('disabled')
      }
    }

    if (this.pageCount) {
      this.pageCount.textContent = this.currentPage
    }

    if (this.pageTotal) {
      this.pageTotal.textContent = this.totalPages
    }
    if (!this.dotsContainer) {
      return
    }

    const currentDot = this.dotsContainer.querySelector(
      `.js-slider-dot[data-page="${this.currentPage - 1}"]`
    )
    if (currentDot) {
      currentDot.classList.add('slider-button--active-dot')
    }
  }

  addDots() {
    if (!this.dotsContainer) {
      return
    }

    let dotsHTML = ''
    for (let i = 0; i < this.totalPages; i++) {
      dotsHTML += `<button
        type="button"
        class="slider-button slider-button--dot${
          i === 0 ? ' slider-button--active-dot' : ''
        } js-slider-dot"
        data-page="${i}"
        aria-label="Navigation Button Page ${i + 1}"
        ></button>`
    }

    this.dotsContainer.innerHTML = dotsHTML
  }

  removeDotsActiveClass() {
    const dots = this.dotsContainer?.querySelectorAll('.js-slider-dot') || []
    dots.forEach((dot) => {
      dot.classList.remove('slider-button--active-dot')
    })
  }

  onButtonClick(event) {
    event.preventDefault()
    const slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
        : this.slider.scrollLeft - this.sliderItems[0].clientWidth
    this.slider.scrollTo({
      left: slideScrollPosition,
    })
  }
}

customElements.define('slider-component', SliderComponent)
